var _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAlert(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.5454 24.546H15.6818V17.046H16.3636V18.4096C16.3636 18.7867 16.6691 19.0914 17.0454 19.0914C17.4218 19.0914 17.7272 18.7867 17.7272 18.4096V14.3187C17.7272 13.9417 17.4218 13.6369 17.0454 13.6369C16.6691 13.6369 16.3636 13.9417 16.3636 14.3187V15.6824H13.6363V14.3187C13.6363 13.9417 13.3309 13.6369 12.9545 13.6369C12.5781 13.6369 12.2727 13.9417 12.2727 14.3187V18.4096C12.2727 18.7867 12.5781 19.0914 12.9545 19.0914C13.3309 19.0914 13.6363 18.7867 13.6363 18.4096V17.046H14.3181V24.546H8.8636V12.9551C8.8636 9.57121 11.6168 6.81871 15 6.81871C18.3831 6.81871 21.1363 9.57121 21.1363 12.9551V22.5005C21.1363 22.8776 21.4418 23.1824 21.8181 23.1824C22.1945 23.1824 22.5 22.8776 22.5 22.5005V12.9551C22.5 8.81985 19.1352 5.45508 15 5.45508C10.8647 5.45508 7.49997 8.81985 7.49997 12.9551V25.2264C7.49997 25.2271 7.49997 25.2278 7.49997 25.2278C7.49997 25.6049 7.80542 25.9096 8.18178 25.9096H24.5454C24.9211 25.9096 25.2272 26.2151 25.2272 26.5914V28.6369H4.77269V26.5914C4.77269 26.2151 5.07883 25.9096 5.45451 25.9096C5.83088 25.9096 6.13633 25.6049 6.13633 25.2278C6.13633 24.8508 5.83088 24.546 5.45451 24.546C4.32678 24.546 3.40906 25.4637 3.40906 26.5914V29.3187C3.40906 29.6958 3.71451 30.0005 4.09088 30.0005H25.9091C26.2854 30.0005 26.5909 29.6958 26.5909 29.3187V26.5914C26.5909 25.4637 25.6731 24.546 24.5454 24.546Z",
    fill: "url(#paint0_linear_2146_13145)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2272 12.9544C10.2272 13.3314 10.5326 13.6362 10.909 13.6362C11.2854 13.6362 11.5908 13.3314 11.5908 12.9544C11.5908 11.0746 13.1201 9.54528 14.9999 9.54528C15.3763 9.54528 15.6817 9.2405 15.6817 8.86346C15.6817 8.48641 15.3763 8.18164 14.9999 8.18164C12.3681 8.18164 10.2272 10.3232 10.2272 12.9544Z",
    fill: "url(#paint1_linear_2146_13145)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9999 4.09091C15.3763 4.09091 15.6818 3.78614 15.6818 3.40909V0.681818C15.6818 0.304773 15.3763 0 14.9999 0C14.6236 0 14.3181 0.304773 14.3181 0.681818V3.40909C14.3181 3.78614 14.6236 4.09091 14.9999 4.09091Z",
    fill: "url(#paint2_linear_2146_13145)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27.2727 12.2734H24.5455C24.1691 12.2734 23.8636 12.5782 23.8636 12.9553C23.8636 13.3323 24.1691 13.6371 24.5455 13.6371H27.2727C27.6491 13.6371 27.9546 13.3323 27.9546 12.9553C27.9546 12.5782 27.6491 12.2734 27.2727 12.2734Z",
    fill: "url(#paint3_linear_2146_13145)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.13632 12.9553C6.13632 12.5782 5.83086 12.2734 5.4545 12.2734H2.72723C2.35086 12.2734 2.04541 12.5782 2.04541 12.9553C2.04541 13.3323 2.35086 13.6371 2.72723 13.6371H5.4545C5.83086 13.6371 6.13632 13.3323 6.13632 12.9553Z",
    fill: "url(#paint4_linear_2146_13145)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M7.76858 6.6886C7.90153 6.82155 8.07608 6.88837 8.25062 6.88837C8.42517 6.88837 8.59971 6.82155 8.73267 6.6886C8.99926 6.42201 8.99926 5.9911 8.73267 5.72451L6.8038 3.79565C6.53721 3.52906 6.1063 3.52906 5.83971 3.79565C5.57312 4.06224 5.57312 4.49315 5.83971 4.75974L7.76858 6.6886Z",
    fill: "url(#paint5_linear_2146_13145)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M21.7492 6.88769C21.9238 6.88769 22.0983 6.82087 22.2313 6.68792L24.1602 4.75974C24.4267 4.49315 24.4267 4.06224 24.1602 3.79565C23.8936 3.52906 23.4627 3.52906 23.1961 3.79565L21.2672 5.72383C21.0006 5.99042 21.0006 6.42133 21.2672 6.68792C21.4008 6.82087 21.5754 6.88769 21.7492 6.88769Z",
    fill: "url(#paint6_linear_2146_13145)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2146_13145",
    x1: 15,
    y1: 5.45508,
    x2: 15,
    y2: 30.0005,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#78264F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B2F68"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2146_13145",
    x1: 12.9544,
    y1: 8.18164,
    x2: 12.9544,
    y2: 13.6362,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#78264F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B2F68"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2146_13145",
    x1: 14.9999,
    y1: 0,
    x2: 14.9999,
    y2: 4.09091,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#78264F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B2F68"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2146_13145",
    x1: 25.9091,
    y1: 12.2734,
    x2: 25.9091,
    y2: 13.6371,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#78264F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B2F68"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2146_13145",
    x1: 4.09086,
    y1: 12.2734,
    x2: 4.09086,
    y2: 13.6371,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#78264F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B2F68"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2146_13145",
    x1: 7.28619,
    y1: 3.5957,
    x2: 7.28619,
    y2: 6.88837,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#78264F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B2F68"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_2146_13145",
    x1: 22.7137,
    y1: 3.5957,
    x2: 22.7137,
    y2: 6.88769,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#78264F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B2F68"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlert);
export default __webpack_public_path__ + "static/media/alert.cdbce9d0.svg";
export { ForwardRef as ReactComponent };